import { Pagination } from '@web/components/ui/pagination';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@web/components/ui/table';

type ProductsTableProps = {
  products?: {
    id: string;
    displayName: string;
    salesPrice: number;
    category: string;
    shortDescription: string;
  }[];
  onDetails?: (product: { id: string }) => void;
  pagination?: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    pageSize: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (pageSize: number) => void;
  };
};

export function ProductsTable({
  products,
  onDetails,
  pagination,
}: ProductsTableProps) {
  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Sales Price</TableHead>
            <TableHead>Description</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {products?.map((product) => (
            <TableRow
              key={product.id}
              onClick={
                onDetails
                  ? () => {
                      onDetails(product);
                    }
                  : undefined
              }
              className="hover:bg-muted/50 cursor-pointer"
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onDetails?.(product);
                }
              }}
              aria-label={`View details for ${product.displayName}`}
            >
              <TableCell>{product.displayName}</TableCell>
              <TableCell>{product.salesPrice}</TableCell>
              <TableCell>{product.shortDescription}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {pagination && (
        <Pagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          totalItems={pagination.totalItems}
          pageSize={pagination.pageSize}
          onPageChange={pagination.onPageChange}
          onPageSizeChange={pagination.onPageSizeChange}
        />
      )}
    </div>
  );
}
